export const ERROR_PATH_FIX_IGNORE = 'p(pathfix-test/j/pinc.auth)';
export const ERROR_401_IGNORE = 'Received status code 401';
